import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledWapper = styled('div')`
  /* .device-list { */
  /* display: ${(props) =>
    props.showConfirmLogoutDialog ? 'none' : 'block'}; */
  /* } */

  .header-manager-wrapper {
    display: flex;
    align-items: center;
    margin: 24px 0 24px 0;
    justify-content: center;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: ${COLOR.darkBlue};
      text-transform: uppercase;
    }
  }
`;

export const StyledActionWarning = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  .cancel-btn {
    display: flex;
    border-radius: 12px;
    border: 1px solid rgba(30, 22, 78, 0.32);
    padding: 10px 24px;
    justify-content: center;
    align-items: center;

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
    height: 40px;
  }

  .agree-btn {
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 12px;
    border: 1px solid ${COLOR.primary};
    background-color: ${COLOR.primary};

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
    height: 40px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .agree-btn,
    .cancel-btn {
      width: 50%;
    }
  }
`;

const StyledManagerDevice = styled('div')`
  padding: ${(props) => (props?.isPopup ? 0 : '24px')};

  .display-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .current-device {
    border-bottom: none !important;
  }

  .other-device {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    height: 48px;

    .MuiTypography-root {
      cursor: pointer;
    }
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      height: 40px;
    }
  }

  .other-device-select {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 8px;
    align-items: center;
    height: 48px;

    .device-select-wrapper {
      display: flex;

      .Mui-checked {
        color: ${COLOR.darkBlue};
      }
    }

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      height: 40px;
    }

    .device-select-btn {
      display: flex;
      gap: 8px;

      @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
        .MuiTypography-root {
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
        }

        .MuiButton-root {
          padding: 4px 8px;
          height: 32px;
        }
      }
    }
  }

  .manager-device-header {
    padding: 0px;
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
  }
  .info-device-wrapper {
    display: flex;
    flex-direction: column;
  }
  .info-device {
    display: flex;
    align-items: center;
    height: 48px;
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      height: 40px;
    }
  }
  .os-info {
    display: flex;
    align-items: center;
  }

  .os-name {
    font-weight: 500;
    font-size: 16px;
    color: #1e1e1e;
    margin-right: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .icon-rounded {
    width: 4px;
    height: 4px;
    margin: 0 4px;
    display: flex;
    align-items: center;
  }

  .tooltip-text {
    font-size: 14px;
    padding: 8px 16px;
    font-weight: 400;
    line-height: 20px;
  }

  .responsive {
    margin: 0;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .responsive {
      display: none;
    }
  }

  .item-device-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #3c3c4329;
    padding: 8px 0;
    box-sizing: border-box;
    width: 100%;
  }

  .device-checkbox {
    padding: 0 !important;
    margin-right: 16px;

    .MuiSvgIcon-root {
      fill: ${COLOR.darkBlue};
    }
  }

  .item-device-info:last-child {
    border-bottom: none;
  }

  .des-device {
    display: flex;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-top: 4px;
    color: #1c1c1ea3;
    flex-direction: 'row';
    gap: 4px;
    align-items: center;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      align-items: ${(props) => !props.isPopup && 'unset'};
      flex-direction: column;
      align-items: start;
    }
  }

  .des-device-detail {
    display: flex;
    align-items: center;
  }

  .total-device {
    height: 24px;
    width: 94px;
    padding: 0px 4px;
    background-color: ${(props) =>
      props?.isExceedDevices ? '#FF3B3014' : COLOR.indigo[8]};
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: ${(props) => (props?.isExceedDevices ? '#FF3B30' : COLOR.darkBlue)};
  }
  .icon-device {
    margin-right: 16px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #1e164ea3;
  }
  .noti-error {
    display: flex;
    font-weight: 400;
    font-size: 12px;
    color: #1c1c1e;
    height: 40px;
    margin-bottom: 16px;
    padding: 0px 8px;
    align-items: center;
    background-color: #ff3b3014;
    border-radius: 8px;
    .info-error-icon {
      margin-right: 2px;
      color: #ff3b30;
    }
    gap: 16px;
    margin-top: 18px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      margin-top: 10px;
      gap: 8px;
    }
  }

  .item-name-device {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 16px;
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      width: ${(props) => props.isPopup && '50vw'};
    }
  }

  .btn-logout {
    padding: 8px;
    cursor: pointer;
    height: 40px;
    width: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all;
    border-radius: 50%;
    flex-shrink: 0; /* Prevent the button from shrinking */
    &:hover {
      background-color: #ff3b3014;
    }
  }
  .table-device {
    .MuiTableHead-root {
      display: none;
    }

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      overflow: ${(props) => !props.isPopup && 'auto'};
    }
  }

  .device-svg {
    width: 24px;
    height: 24px;
  }

  .title-device {
    font-weight: 500;
    font-size: 20px;
    margin-right: 12px;
    line-height: 28px;
    color: ${COLOR.darkGray};

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 16px;
    }
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    color: ${COLOR.darkBlue};
  }

  .description {
    padding: 0px 20px;
    margin-bottom: 16px;
    font-size: 16px;
  }

  .blue-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #34c759;
  }
`;

const StyledChip = styled(Typography)`
  background-color: ${({ color }) => TRANSPARENT_COLOR[color]};
  color: ${({ color }) => COLOR[color]};
  padding: 1px 10px;
  border-radius: 17px;
  font-size: 14px;
  font-weight: 500;
  width: fit-content;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledOSName = styled('div')`
  display: flex;
  align-items: center;
  height: 16px;
  width: 80px;
  font-size: 12px;
  font-weight: 400;
  padding: 1px 1px;
  justify-content: center;
  border-radius: 100px;
  background-color: #34c75914;
  color: ${COLOR.greenV2.default};
  .blue-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 2px;
    background-color: ${COLOR.greenV2.default};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    height: 24px;
    width: 75px;
    font-size: 12px;
    padding: 0px 8px;
  }
`;

const StyledAction = styled('div')`
  color: ${COLOR.primary};
  cursor: pointer;
  font-size: 14px;
`;

export {
  StyledManagerDevice,
  StyledWapper,
  StyledChip,
  StyledOSName,
  StyledAction,
};
